enum FuelType {
  GAS = 'Gas',
  ELECTRIC = 'Electric',
  HYBRID = 'Hybrid',
  PLUG_IN_HYBRID = 'Plug-In Hybrid',
}
export default FuelType;

export type VerifyProductType = Utils.VerifyExtends<Model.Enum.FuelType, Utils.ValueOf<typeof FuelType>>;
